import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import BusTabs from "../AllTabs/BusTabs";
import moment from "moment";

const BusBookings = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [pageLoading, setPageLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [lists, setLists] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  // Fetch bus bookings data
  const GetData = async (pageNumber) => {
    setPageLoading(true);
    try {
      const res = await apiService.post(
        `${config.GETPARENTCOMPANYBUSBOOKINGS}/${user?.cid}`,
        pageSize,
        pageNumber
      );
      console.log(res);
      setLists(res);
    } catch (error) {
      console.error("Error fetching bus bookings:", error);
    } finally {
      setPageLoading(false);
    }
  };

  // Handle booking confirmation
  const handleConfirm = async (e, busBookingId) => {
    setPageLoading(true);
    try {
      const res = await apiService.post(
        `${config.CONFIRMHOLDBUSBOOKING}/${busBookingId}`,
        pageSize,
        pageNumber
      );
      console.log(res);
      navigate("/bus/booking/" + busBookingId);
    } catch (error) {
      console.error("Error confirming booking:", error);
    }
  };

  // Format amount with currency
  const formatCurrency = (amount) => {
    const num = parseFloat(amount) || 0;
    return `INR${Math.round(num).toLocaleString("en-IN")}`;
  };
  // Get status badge class
  const getStatusBadgeClass = (status) => {
    switch (status?.toUpperCase()) {
      case "CONFIRMED":
      case "SUCCESS":
      case "BOOKED":
        return "bg-success";
      case "PENDING":
      case "HOLD":
      case "BLOCKED":
        return "bg-warning";
      case "CANCELLED":
      case "FAILED":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };

  // Get payment status badge class
  const getPaymentBadgeClass = (status) => {
    switch (status?.toUpperCase()) {
      case "SUCCESS":
        return "bg-success";
      case "PENDING":
        return "bg-warning";
      case "FAILED":
        return "bg-danger";
      default:
        return "bg-secondary";
    }
  };

  useEffect(() => {
    if (user && !loading) {
      GetData(pageNumber);
    }
  }, [user, loading, pageNumber]);

  if (loading) return <p>Loading...</p>;
  if (!user) {
    navigate("/");
  }

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <BusTabs pageName="BUSBOOKINGS" />
                </div>
                <div className="card-body">
                  {/* Search and Filters */}
                  {/* <div className="row mb-3">
                    <div className="col-md-3">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search booking..."
                          onChange={(e) => {
                            // Add search functionality here
                          }}
                        />
                        <button className="btn btn-primary" type="button">
                          <i className="ri-search-line"></i>
                        </button>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <select className="form-select">
                        <option value="">All Status</option>
                        <option value="BOOKED">Booked</option>
                        <option value="BLOCKED">Blocked</option>
                        <option value="PENDING">Pending</option>
                        <option value="CANCELLED">Cancelled</option>
                      </select>
                    </div>
                    <div className="col-md-2">
                      <select className="form-select">
                        <option value="">All Payment Status</option>
                        <option value="SUCCESS">Success</option>
                        <option value="PENDING">Pending</option>
                        <option value="FAILED">Failed</option>
                      </select>
                    </div>
                  </div> */}

                  {/* Bookings Table */}
                  <div className="table-responsive table-card p-2">
                    <table className="table align-middle" id="busBookingTable">
                      <thead className="bg-soft-info bg-gradient">
                        <tr>
                          <th>Id</th>
                          <th>Booking Details</th>
                          <th>Route & Date</th>
                          <th>Operator & Bus</th>
                          <th>Passenger</th>
                          <th>Booking Status</th>
                          <th>Payment Status</th>
                          <th>Amount</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      {pageLoading === true ? (
                        <tbody className="list form-check-all text-center">
                          <tr>
                            <td colSpan={9}>
                              <img
                                src="/assets/images/loader.webp"
                                width={"64px"}
                                height={"64px"}
                                alt="Loading..."
                              />
                              Loading, Please wait...
                            </td>
                          </tr>
                        </tbody>
                      ) : (
                        <tbody className="list form-check-all">
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={v.busBookingId}>
                                <td>{index + 1}</td>
                                <td>
                                  <div className="fw-medium">{v.bookingNo}</div>
                                  <div className="text-muted small">
                                    PNR: {v.pnr || "N/A"}
                                  </div>
                                  <div className="text-muted small">
                                    {v.supplierName}
                                  </div>
                                </td>
                                <td>
                                  <div className="fw-medium">
                                    {v.sourceCity} → {v.destinationCity}
                                  </div>
                                  <div className="text-muted small">
                                    Departure:{" "}
                                    {moment(v.departureDate).format(
                                      "DD MMM YYYY "
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <div className="fw-medium">
                                    {v.operatorName}
                                  </div>
                                  <div className="text-muted small">
                                    {v.busType}
                                  </div>
                                  <div className="text-muted small">
                                    {v.journeyType}
                                  </div>
                                </td>
                                <td>
                                  <div className="fw-medium">
                                    {v.passengerName}
                                  </div>
                                  <div className="text-muted small">
                                    Passengers: {v.noOfPassengers}
                                  </div>
                                  <div className="text-muted small">
                                    {v.customerPhone}
                                  </div>
                                </td>
                                <td>
                                  <span
                                    className={`badge ${getStatusBadgeClass(
                                      v.supplierBookingStatus
                                    )}`}
                                  >
                                    {v.supplierBookingStatus}
                                  </span>
                                  {/* {v.supplierBookingStatus &&
                                    v.supplierBookingStatus !==
                                      v.bookingStatus && (
                                      <div className="text-muted small mt-1">
                                        Supplier: {v.supplierBookingStatus}
                                      </div>
                                    )} */}
                                </td>
                                <td>
                                  <span
                                    className={`badge ${getPaymentBadgeClass(
                                      v.paymentStatus
                                    )}`}
                                  >
                                    {v.paymentStatus}
                                  </span>
                                  {v.paymentGateway && (
                                    <div className="text-muted small mt-1">
                                      {v.paymentGateway}
                                    </div>
                                  )}
                                </td>
                                <td>
                                  <div className="fw-bold text-primary">
                                    {formatCurrency(v.totalPrice)}
                                  </div>
                                  {/* <div className="text-muted small">
                                    Fare: {formatCurrency(v.totalFare)}
                                  </div> */}
                                  {/* {v.convenienceFee > 0 && (
                                    <div className="text-muted small">
                                      Fee: {formatCurrency(v.convenienceFee)}
                                    </div>
                                  )} */}
                                </td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    {v.bookingStatus === "BLOCKED" && (
                                      <li className="list-inline-item">
                                        <button
                                          onClick={(e) =>
                                            handleConfirm(e, v.busBookingId)
                                          }
                                          className="btn btn-sm btn-success"
                                          title="Confirm Booking"
                                        >
                                          <i className="ri-check-line"></i>
                                        </button>
                                      </li>
                                    )}
                                    <li className="list-inline-item">
                                      <Link
                                        to={`/bus/booking/${v.busBookingId}`}
                                        className="btn btn-sm btn-primary"
                                        title="View Details"
                                      >
                                        <i className="ri-eye-line"></i>
                                      </Link>
                                    </li>
                                    {/* <li className="list-inline-item">
                                      <button
                                        className="btn btn-sm btn-outline-secondary"
                                        title="Download Ticket"
                                      >
                                        <i className="ri-download-line"></i>
                                      </button>
                                    </li>
                                    {v.bookingStatus === "BOOKED" && (
                                      <li className="list-inline-item">
                                        <button
                                          className="btn btn-sm btn-danger"
                                          title="Cancel Booking"
                                        >
                                          <i className="ri-close-line"></i>
                                        </button>
                                      </li>
                                    )} */}
                                  </ul>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={9} className="text-center py-4">
                                <div className="text-muted">
                                  <i className="ri-bus-line display-4"></i>
                                  <h5 className="mt-2">
                                    No Bus Bookings Found
                                  </h5>
                                  <p className="mb-0">
                                    Start booking bus tickets to see them here.
                                  </p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      )}
                    </table>
                  </div>

                  {/* Pagination */}
                  {totalPages > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div className="text-muted">
                        Showing {(pageNumber - 1) * pageSize + 1} to{" "}
                        {Math.min(pageNumber * pageSize, totalRecords)} of{" "}
                        {totalRecords} entries
                      </div>
                      <nav aria-label="Page navigation">
                        <ul className="pagination mb-0">
                          <li
                            className={`page-item ${
                              pageNumber === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setPageNumber(pageNumber - 1)}
                              disabled={pageNumber === 1}
                            >
                              Previous
                            </button>
                          </li>
                          {[...Array(Math.min(5, totalPages)).keys()].map(
                            (i) => (
                              <li
                                key={i}
                                className={`page-item ${
                                  pageNumber === i + 1 ? "active" : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => setPageNumber(i + 1)}
                                >
                                  {i + 1}
                                </button>
                              </li>
                            )
                          )}
                          {totalPages > 5 && (
                            <>
                              <li className="page-item disabled">
                                <span className="page-link">...</span>
                              </li>
                              <li
                                className={`page-item ${
                                  pageNumber === totalPages ? "active" : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => setPageNumber(totalPages)}
                                >
                                  {totalPages}
                                </button>
                              </li>
                            </>
                          )}
                          <li
                            className={`page-item ${
                              pageNumber === totalPages ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link"
                              onClick={() => setPageNumber(pageNumber + 1)}
                              disabled={pageNumber === totalPages}
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusBookings;
